import { createFileRoute } from '@tanstack/react-router';
import { CardsPage } from '../components/pages/CardsPage/CardsPage';

export const Route = createFileRoute('/account/cards')({
  component: CardsPage,
});
